<template>
  <v-card>
    <v-card-title>
      <router-link
        :to="{ name: 'feedback_form', params: { user_id: userId } }"
        v-if="can_add()"
      >
        <v-btn fab class="mt-n4" :color="color">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </router-link>

      <p class="pl-5">
        <v-row
          ><v-img
            class="pl-5"
            src="/icons/feedback.png"
            :aspect-ratio="1"
            width="40"
          />{{ $tc("feedback.title", 2) }}</v-row
        >
      </p>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="feedbacks"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="$store.state.feedback.totalCount"
      dense
      show-expand
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td class="pt-5" :colspan="headers.length">
          <Feedback :feedback="item" />
        </td>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.date="{ item }">
        {{ item.date | date }}
      </template>

      <template #item.author="{ item }">
        <User :user="item.author" />
      </template>
      <template #item.link_mission="{ item }">
        <table-item-tool-tip :text="item.link_mission"></table-item-tool-tip>
      </template>
      <template #item.overall_impression="{ item }">
        <table-item-tool-tip
          :text="item.overall_impression"
        ></table-item-tool-tip>
      </template>
      <template #item.detailed_assessment="{ item }">
        <table-item-tool-tip
          :text="item.detailed_assessment"
        ></table-item-tool-tip>
      </template>
      <template #item.recommendation="{ item }">
        <table-item-tool-tip :text="item.recommendation"></table-item-tool-tip>
      </template>
      <template #item.follow_instruction="{ item }">
        <table-item-tool-tip
          :text="item.follow_instruction"
        ></table-item-tool-tip>
      </template>

      <template #item.visible_by="{ item }">
        {{ $t(item.visible_by.includes("PEF") ? "common.yes" : "common.no") }}
      </template>
      <template #item.actions="{ item }">
        <EditDelete
          v-if="can_edit(item)"
          @delete="remove('feedback', item)"
          :edit-path="{
            name: 'feedback_form_edit',
            params: { feedback_id: item.id, user_id: userId },
          }"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import User from "@/components/card/User"
import Feedback from "@/components/item/Feedback"
import TableMixin from "@/mixins/TableMixin"
import EditDelete from "@/components/form/EditDelete"
import TableItemToolTip from "@/components/TableItemToolTip.vue"

const { mapActions } = createNamespacedHelpers("feedback")

export default {
  name: "FeedbacksTable",
  components: { TableItemToolTip, EditDelete, Feedback, User },
  mixins: [TableMixin],
  computed: {
    feedbacks() {
      return this.$store.state.feedback.data
    },

    headers() {
      let result = [
        {
          value: "date",
          text: this.$tc("common.date", 1),
          align: " text-no-wrap",
        },
        {
          value: "author",
          text: this.$tc("common.author", 1),
          width: "10%",
          align: " text-no-wrap",
        },
        {
          value: "link_mission",
          text: this.$t("feedback.link_mission.title"),
          width: "20%",
        },
        {
          value: "overall_impression",
          text: this.$t("feedback.overall_impression.title"),
          width: "20%",
        },
        {
          value: "detailed_assessment",
          text: this.$t("feedback.detailed_assessment.title"),
          width: "20%",
          align: " text-no-wrap",
        },
        {
          value: "recommendation",
          text: this.$t("feedback.recommendation.title"),
          width: "15%",
          align: " text-no-wrap",
        },
        {
          value: "follow_instruction",
          text: this.$t("feedback.follow_instruction.title"),
          width: "15%",
          align: " text-no-wrap",
        },
      ]
      if (!["PEF", "ASPIRANT"].includes(this.current_user.role)) {
        result.push({
          value: "visible_by",
          text: this.$t("feedback.visible_by_pef"),
          width: "5%",
          align: " text-no-wrap",
        })
      }
      result.push({
        value: "actions",
        align: "right",
        width: "1%",
      })
      return result
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.user_id_local = this.$route.params.user_id
      this.getDataFromApi()
    },
  },
  methods: {
    ...mapActions([FETCH]),
    can_edit(item) {
      return (
        ["ADMIN", "SUPERADMIN"].includes(this.current_user.role) ||
        item.author.id === this.current_user.id
      )
    },
    can_add() {
      return !["PEF", "ASPIRANT"].includes(this.current_user.role) && this.$store.state.user.item.can_edit
    },
  },
}
</script>
